import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import ResponsiveNav from "../ResponsiveNav/component";
import RegionalNav from "../RegionalNav/component";
import OlympicsResponsiveNav from "../OlympicsResponsiveNav/component";
import OlympicsBrandBanner from "../../../../pages/FlexibleLandingPage/components/OlympicsBrandBanner/component";
import { SUB_NAV_LIST } from "../../constants";
import { isAdvertorial } from "../../../../utils/sponsor/library";
import { isOlympics, getOlympicsSeason } from "../../../../utils/path/library";
import "./styles/themes/_default.scss";

const LandingNav = ({
    baseNavSection,
    subSection,
    path,
    viewport,
    regionObject,
    gemDepartment,
    isExternalHeader,
}) => {
    const sponsorLabel = useSelector((state) =>
        state.detail && state.detail.content && state.detail.content.sponsorBio
            ? state.detail.content.sponsorBio.label
            : null
    );

    if (isAdvertorial(sponsorLabel)) {
        return null;
    }

    // Get the navigation JSON object from the config file
    const subNavListAll = SUB_NAV_LIST[baseNavSection];

    // Filter out the hidden subnav item from the navigation
    let subNavListMenuDisplay = subNavListAll
        ? subNavListAll.filter((obj) => {
              return obj.hidden !== true;
          })
        : null;

    // If it's a regional page, get the navigation from a different config object
    if (regionObject) {
        subNavListMenuDisplay = regionObject.navigation
            ? regionObject.navigation
            : [];
    }

    const navProps = {
        baseNavSection,
        subSection,
        path,
        showLogo: true,
        items: subNavListMenuDisplay,
        viewport,
        gemDepartment,
        isExternalHeader,
    };

    const isOlympicsBaseNavSection = isOlympics({
        baseNavSection,
    });

    let navToRender = <ResponsiveNav {...navProps} />;
    let brandBanner = null;

    if (regionObject) {
        navToRender = (
            <RegionalNav {...navProps} sectionTitle={regionObject.title} />
        );
    } else if (isOlympicsBaseNavSection) {
        navToRender = <OlympicsResponsiveNav {...navProps} />;
        brandBanner = (
            <OlympicsBrandBanner
                season={getOlympicsSeason({
                    baseNavSection,
                })}
            />
        );
    }

    return (
        <nav
            className="sclt-landingnav landingNav"
            aria-label={`CBC ${baseNavSection || ""}`}
        >
            {brandBanner}
            <div className="landingWrapper" data-testid="nav-landing-wrapper">
                {navToRender}
            </div>
        </nav>
    );
};

LandingNav.propTypes = {
    baseNavSection: PropTypes.string,
    subSection: PropTypes.string,
    path: PropTypes.string,
    viewport: PropTypes.string,
    regionObject: PropTypes.object,
    gemDepartment: PropTypes.object,
    isExternalHeader: PropTypes.bool,
};

export default LandingNav;
